/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'components/utils/globals';
require.context('images/', true, /\.(jpg|gif|png|svg)$/i);
import 'css/2018.scss';
import { hot } from 'react-hot-loader';
import ShowcaseSlider from 'components/showcase_slider';
import HeaderSlider from 'components/header_slider';
import ResidentsAnimations from 'components/residents_animations';
import HomesAnimations from 'components/homes_animations';
import SiteNav from 'components/site_nav';
import ImageModal from 'components/image_modal';
import JustMoveIn from 'components/just_move_in/just_move_in';
import ListingsCollection from 'components/listings/listings_collection';
import scrollManager from 'scroll-manager';
import viewings from 'viewings';
import HomeActionsManager from 'components/book_viewing/home_actions_manager';
import CookieOptIn from 'components/cookie_opt_in';
import PhotoGalleryModal from 'components/photo_gallery_modal';
import KeyFeaturesList from 'components/listings/key_features_list';
import VirtualTourButton from 'components/virtual_tour_button';
import PropertyMap from 'components/property_map';
import AgentForm from 'components/agent_form';
import CoBrandingBanner from 'components/listings/co_branding_banner';
import CoBrandingImage from 'components/listings/co_branding_image';

ResidentsAnimations.init();
HomesAnimations.init();
scrollManager();
viewings();

import WebpackerReact from 'webpacker-react';

WebpackerReact.setup({
  ShowcaseSlider: hot(module)(ShowcaseSlider),
  HeaderSlider: hot(module)(HeaderSlider),
  SiteNav: hot(module)(SiteNav),
  ImageModal: hot(module)(ImageModal),
  JustMoveIn: hot(module)(JustMoveIn),
  ListingsCollection: hot(module)(ListingsCollection),
  HomeActionsManager: hot(module)(HomeActionsManager),
  CookieOptIn: hot(module)(CookieOptIn),
  PhotoGalleryModal: hot(module)(PhotoGalleryModal),
  KeyFeaturesList: hot(module)(KeyFeaturesList),
  VirtualTourButton: hot(module)(VirtualTourButton),
  PropertyMap: hot(module)(PropertyMap),
  AgentForm: hot(module)(AgentForm),
  CoBrandingBanner: hot(module)(CoBrandingBanner),
  CoBrandingImage: hot(module)(CoBrandingImage),
});
